import { NgModule } from '@angular/core';

import { MenuButtonComponent } from '../menu-button/menu-button.component';

@NgModule({
  imports: [
    MenuButtonComponent,
  ],
  exports: [
    MenuButtonComponent,
  ],
  declarations: [],
  providers: [],
})
export class SharedComponentsModule {
}
